var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0973 37.509H7.9226C6.80198 37.4893 5.73458 37.0264 4.95445 36.2217C4.17433 35.4169 3.7451 34.336 3.76015 33.2153V11.7839C3.7451 10.6633 4.17433 9.5823 4.95445 8.77758C5.73458 7.97286 6.80198 7.50997 7.9226 7.49023H37.0973C38.2179 7.50997 39.2853 7.97286 40.0654 8.77758C40.8455 9.5823 41.2752 10.6633 41.2602 11.7839V33.2153C41.2752 34.336 40.8455 35.4169 40.0654 36.2217C39.2853 37.0264 38.2179 37.4893 37.0973 37.509V37.509Z",
    stroke: "#656363",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75977 15.0098L22.5098 22.5098L41.2598 15.0098",
    stroke: "#656363",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgImg);
export default __webpack_public_path__ + "static/media/MsgImg.3eaea40a39231fef5ee52b947b7ec2d4.svg";
export { ForwardRef as ReactComponent };